import { render } from "./TodayLecture.vue?vue&type=template&id=5ab58a28&scoped=true"
import script from "./TodayLecture.vue?vue&type=script&lang=js"
export * from "./TodayLecture.vue?vue&type=script&lang=js"

import "./TodayLecture.vue?vue&type=style&index=0&id=5ab58a28&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ab58a28"]])

export default __exports__